// extracted by css-extract-rspack-plugin
export default {"wrapperCheckout":"footer-fragment__ContractCancellationButton_wrapperCheckout__SRCxt"};